import React from "react";
import { Code2, Zap } from "lucide-react";

function About() {
  const achievements = [
    { icon: <Code2 size={32} />, number: "20+", label: "Projects Built" },
    { icon: <Zap size={32} />, number: "3+", label: "Months Experience" },
  ];

  return (
    <>
    <section id="about" className="hero text-light">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 order-md-1 mb-4 mb-md-0">
            <h1 className="fw-bold">Hi, I’m <span className="highlight">Smit Fataniya</span> 👋</h1>
            <p className="lead mt-3">
              I build scalable, user-friendly web applications using <strong>React</strong>, <strong>Node.js</strong>, and modern tools. I focus on product-driven development and clean code.
            </p>

            <div className="mt-4">
              <a href="/resume.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-accent btn-cta me-2" aria-label="Download resume">Download Resume</a>
              <a href="mailto:youremail@example.com" className="btn btn-outline-accent btn-cta" aria-label="Hire me">Hire me</a>
            </div>

            <p className="mt-4" style={{ color: "#8b949e" }}>
              Available for full-time roles and freelance contracts. Open to relocation and remote opportunities.
            </p>
          </div>

          <div className="col-md-6 text-center order-md-0">
            <img
              src="/profile.jpg"
              alt="Profile"
              className="img-fluid rounded-circle shadow"
              style={{ border: "4px solid #161b22", maxWidth: "260px" }}
            />
          </div>
        </div>
      </div>
    </section>

    <section id="achievements" className="py-5 text-light">
      <div className="container">
        <div className="row g-4">
          {achievements.map((item, idx) => (
            <div className="col-md-4" key={idx}>
              <div className="stat-box">
                <div className="text-info mb-3">{item.icon}</div>
                <div className="stat-number">{item.number}</div>
                <div className="stat-label">{item.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
  );
}

export default About;
